var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDollarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8325 10.9444C19.8325 15.8536 15.8527 19.8333 10.9436 19.8333C6.03438 19.8333 2.05469 15.8536 2.05469 10.9444C2.05469 6.03523 6.03438 2.05554 10.9436 2.05554C15.8527 2.05554 19.8325 6.03523 19.8325 10.9444Z",
    stroke: "white",
    strokeWidth: 1.33333
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3539 9.22097C13.2659 8.54305 12.4875 7.44774 11.0878 7.44772C9.4615 7.44769 8.7772 8.3484 8.63834 8.79876C8.42172 9.40115 8.46504 10.6396 10.3713 10.7747C12.7541 10.9435 13.7087 11.2248 13.5873 12.6831C13.4658 14.1413 12.1375 14.4564 11.0878 14.4226C10.038 14.3889 8.32056 13.9067 8.25391 12.6096M10.9212 6.49826V7.45095M10.9212 14.4139V15.3871",
    stroke: "white",
    strokeWidth: 1.33333,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarIcon);
export default __webpack_public_path__ + "static/media/dollarIcon.3f97477646180cf010ac98d59ff0b337.svg";
export { ForwardRef as ReactComponent };